import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const CompliancePage = () => {
  const { id, docId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/org-documents/${docId}/compliance`)
      .then(r => setData(r.data)).catch(() => toast.error('Failed to load')).finally(() => setLoading(false));
  }, [docId]);

  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!data) return <div className="page-content"><p>Not found.</p></div>;

  const { document, compliance, summary } = data;
  const badge = (s) => {
    if (s === 'done') return <span className="badge badge-green">✓ Signed</span>;
    if (s === 'expired') return <span className="badge badge-amber">Expired</span>;
    return <span className="badge badge-red">Pending</span>;
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)', paddingBottom: 40 }}>
      <div className="top-bar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button onClick={() => navigate(`/organizations/${id}/documents`)} style={{ background: 'none', border: 'none', color: 'white', cursor: 'pointer', fontSize: 20, padding: '4px 8px 4px 0' }}>‹</button>
          <h1 style={{ color: 'white', fontSize: 17, flex: 1 }}>{document.title}</h1>
        </div>
      </div>

      <div style={{ padding: 12 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8, marginBottom: 12 }}>
          <div className="card" style={{ textAlign: 'center', margin: 0 }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--cr-green)' }}>{summary.done}</div>
            <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Signed</div>
          </div>
          <div className="card" style={{ textAlign: 'center', margin: 0 }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--cr-red)' }}>{summary.pending}</div>
            <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Missing</div>
          </div>
          <div className="card" style={{ textAlign: 'center', margin: 0 }}>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--cr-amber)' }}>{summary.expired}</div>
            <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Expired</div>
          </div>
        </div>

        <div className="section-label">Members ({summary.total})</div>
        {compliance.map(row => (
          <div key={row.account_id} className="card" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>{row.name}</div>
              {row.signed_at && <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>Signed {new Date(row.signed_at).toLocaleDateString()}</div>}
            </div>
            {badge(row.status)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompliancePage;
